module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "url('static/images/b.jpeg') no-repeat center center",
      "background-size": "cover"
    },
    attrs: {
      "id": "log-in"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "register"
    }
  }, [_c('h1', [_vm._v("Sign Up!")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.supplierRegister($event)
      }
    }
  }, [_c('h3', [_vm._v("Account Information")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Full name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Full name"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "username",
      "id": "username",
      "placeholder": "username"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "email",
      "id": "email",
      "placeholder": "email"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "password"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "id": "password_confirmation",
      "placeholder": "Confirm Password"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Supplier Information")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "company_name"
    }
  }, [_vm._v("Company Name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "company_name",
      "id": "company_name",
      "placeholder": "Company name"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "company_address"
    }
  }, [_vm._v("Company Address")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "company_address",
      "id": "company_address",
      "placeholder": "Company address"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "contact_number"
    }
  }, [_vm._v("Contact Number")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "contact_number",
      "id": "contact_number",
      "placeholder": "Contact number"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "value"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Register")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "id": "supplierinfo"
    }
  }, [_c('h1', [_vm._v("Supplier Registration")]), _vm._v(" "), _c('p', [_vm._v("this template currently applies for suppliers")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Post your products")]), _vm._v(" "), _c('li', [_vm._v("Get notifications and feedbacks about your products")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d96fcbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplier.vue
// module id = 151
// module chunks = 0